import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import IndexRepository from "../Repositories/IndexRepository";

class IndexBloc {
  rowtableChannel = new Subject();
  detailChannel = new Subject();
  eselonChannel = new Subject();
  rankChannel = new Subject();
  workUnitChannel = new Subject();
  updateChannel = new Subject();
  createChannel = new Subject();
  draftChannel = new Subject();
  deleteChannel = new Subject();
  repository = new IndexRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.eselonChannel.next({ status: apiResponse.INITIAL });
    this.rankChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.updateChannel.next({ status: apiResponse.INITIAL });
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.draftChannel.next({ status: apiResponse.INITIAL });
  }
  fetchDelete = async (query) => {
    this.deleteChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchDelete(query)
      .then((result) => {
        this.deleteChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.deleteChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchRowTable = async (query, cancelToken) => {
    try {
      this.rowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchDetail = async (query) => {
    this.detailChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchDetail(query)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchEselon = async (query) => {
    try {
      this.eselonChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEselon(query)
        .then((result) => {
          this.eselonChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.eselonChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchRank = async (query) => {
    try {
      this.rankChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRank(query)
        .then((result) => {
          this.rankChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rankChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchUpdate = async (query) => {
    try {
      this.updateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdate(query)
        .then((result) => {
          this.updateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchDraft = async (query) => {
    try {
      this.draftChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDraft(query)
        .then((result) => {
          this.draftChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.draftChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };
}

export default IndexBloc;
